import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';
import * as Objects from '@core/objects';
import { UrlService } from '@core/services/url/url.service';

@Component({
    selector: 'form-field-view-artwork-link-selector-v1',
    templateUrl: './view-artwork-link-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewArtworkLinkSelectorV1FieldComponent implements OnInit {
    @Input() fieldSubmission: CustomFormFieldSubmission;


    constructor(private urlSrv: UrlService) {}

    ngOnInit(): void {
        
    }

    /**
     * 
     * @param file the file inside artwork result or selected.
     * For now the action will be download it.
     */
    onFileClick(file: Objects.File) {
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

}
